import merge from 'lodash/merge';
import { t } from '@data/other/i18n';
export const isEmailPattern = /^\w+(['+.-]\w+)*@\w+([.-]\w+)*\.\w+([.-]\w+)*$/;
export const emailValidate = (value) => {
    if (!isEmailPattern.test(value)) {
        return t('validation/email');
    }
    return undefined;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createValidation = (validation, additionalRules) => merge({}, validation, additionalRules);
